<h1 mat-dialog-title class="border-bottom">Ingrese el monto del rendimiento</h1>

<mat-dialog-content class="mat-typography">

    <mat-form-field class="col-md-12">
        <span matPrefix>$&nbsp;</span>

        <input matInput placeholder="Rendimiento:" type="number" [(ngModel)]="revenueAmount" required>
      </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="col-md-4 offset-md-1">
        <button mat-button (click)="cancel()" class="btn btn-outline-secondary">Cancelar</button>
    </div>
    <div class="col-md-4">
        <button [mat-dialog-close]="revenueAmount" cdkFocusInitial class="btn btn-primary">Calcular</button>
    </div>

  </mat-dialog-actions>
